<div class="no-claims">
  <div class="row text-center">
    <div class="col">
      <h1 class="claims-title no-claims-title">{{ "You don't have any active claims at this time." | translate }}</h1>
    </div>
  </div>
  <div class="row text-center">
    <div class="col">      
      <app-claims-report [placement]="'noclaims'"></app-claims-report>
    </div>
  </div>
</div>